export const CUSTOM_MUTATION = 'CUSTOM_MUTATION'
export const BUST_CACHE = 'BUST_CACHE'
export const CUSTOM_MUTATION_SUCCESS = `${CUSTOM_MUTATION}_SUCCESS`
export const CHANGE_UI = 'CHANGE_UI'
